import clsx from 'clsx'
import styles from './controls.module.css'
import type { FilterOption, FilterTierGroup } from 'lib/dealhunt/types'

interface TiersControlProps {
  group: FilterTierGroup
  onOption: (option: FilterOption, on: boolean) => void
}

/** Cumulative "at least" rows — one selected at a time (the backend computes the
 *  inclusive counts: picking "Sweat & rain · IPX5+" includes every IPX7 pair).
 *  Single-select, so it reads as a radio group (FilterGroupView routes it that way). */
const TiersControl: React.VFC<TiersControlProps> = ({ group, onOption }) => (
  <div role="radiogroup" aria-label={group.label}>
    {group.options.map(opt => (
      <button
        key={opt.value}
        type="button"
        role="radio"
        className={clsx(styles.tierRow, { [styles.tierActive]: opt.selected })}
        aria-checked={opt.selected}
        onClick={() => onOption(opt, !opt.selected)}
      >
        <span>{opt.label}</span>
        <span className={styles.tierCount}>{opt.count.toLocaleString('en-US')}</span>
      </button>
    ))}
  </div>
)

export default TiersControl
